import { requester } from '../api'

type PostForm = {
  content: string
  images: string[]
}

export const postService = {
  createPost: async (cat_id: string, data: PostForm) => {
    const response = await requester.post(`/posts/${cat_id}`, data)
    return response
  },
}
